import { ServicosGuard } from './service/core/servicos-guard.service';
import { AuthGuard } from './service/core/auth-guard.service';
import { Routes } from '@angular/router';

export const AppRoutes: Routes =
    [{
        path: '',
        redirectTo: 'dashboard-simples',
        pathMatch: 'full',

    }, {
        path: '',
        children: [{
            path: '',
            loadChildren: () => import('./modules/inscricao-publica/inscricao-publica.routing').then(m => m.InscricaoPublicaRoutes)
        }]
    }, {
        path: '',
        canActivate: [ServicosGuard],
        children: [{
            path: '',
            loadChildren: () => import('./auth/auth.routing').then(m => m.AuthRoutes)
        }]
    }, {
        path: '',
        canActivate: [AuthGuard, ServicosGuard],
        children: [{
            path: '',
            loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
        }],
    }];
    //{ path: '**', redirectTo: '/notfound' }

